<template>
  <div class="donate-carousel ra-hub-carousel">
    <VueSlickCarousel v-bind="settings" @afterChange="changeIndex">
      <div class="slide" v-for="(item, i) in slides" :key="i">
        <a @click="handleClick(item.link)">
          <div class="slide-image" :style="'background-image: url('+ item.image +')'"></div>
        </a>
      </div>
    </VueSlickCarousel>

    <div class="slide-copy">
      <h4>{{ slides[slideIndex].title }}</h4>
      <p>{{ slides[slideIndex].text }}</p>
    </div>
  </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel';

export default {
  name: "RaHubCarousel",
  components: {
    VueSlickCarousel,
  },

  props: {
    slides: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      slideIndex: 0,

      settings: {
        "infinite": true,
        "responsive": [
          {
            "breakpoint": 640,
            "settings": {
              "centerMode": true,
              "arrows": false
            }
          },
        ]
      },
    }
  },
  
  methods: {
    changeIndex(slideIndex) {
      this.slideIndex = slideIndex;
    },

    handleClick(url) {
      this.$store.dispatch("logContentLink", url)
      .then(() => window.location.href = url);
    }
  }
};
</script>

<style scoped>
  .slide {
    padding: 0 5px;
  }

  .slide-copy {
    margin-top: 1rem;
    padding: 0 60px;
  }

  .slide-image {
    padding-top: 63%;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }

  .ra-hub-carousel >>> button.slick-arrow.slick-prev,
  .ra-hub-carousel >>> button.slick-arrow.slick-next {
    top: 50%;
    width: 4rem;
  }

  .ra-hub-carousel >>> button.slick-arrow.slick-prev {
    left: 0;
  }

  .ra-hub-carousel >>> button.slick-arrow.slick-next {
    right: 0;
  }

  @media only screen and (min-width: 641px) {
    .slide,
    .slide-copy {
      padding: 0 4rem;
    }
  }
</style>


// WEBPACK FOOTER //
// RaHubCarousel.vue?31a10215